import angular from 'angular';
import Admin from './admin/admin'
import Login from './login/login';
import User from './user/user';
import Unauthorized from './unauthorized/unauthorized';
import Vehicle from './vehicle/vehicle';
import Notes from './common/notes/notes';
import EntityManagement from './entityManagement/entityManagement';
import AccessoryManagement from './accessoryManagement/accessoryManagement';
import PriceManagement from './priceManagement/priceManagement';
import Company from './company/company';
import Contact from './contact/contact';
import Address from './common/address/address';
import ContactPhones from './common/contactPhones/contactPhones';
import ContactEmails from './common/contactEmails/contactEmails';
import GaugeChart from './common/gaugeChart/gaugeChart';
import Enquiry from './enquiry/enquiry';
import WelcomeCentre from './welcomeCentre/welcomeCentre';
import Messaging from './messaging/messaging';
import Dashboard from './dashboard/dashboard';
import Promise from './promise/promise';
import Reports from './reports/reports';
import Finance from './finance/finance';
import OmniSearch from './omniSearch/omniSearch';
import WebEnquiriesService from './webEnquiries/webEnquiries.service';
import KpiAnalytics from './kpiAnalytics/kpiAnalytics';
import LeadMonitor from './leadMonitor/leadMonitor';
import PrivacyPolicy from './privacyPolicy/privacyPolicy';
import Accounting from './accounting/accounting';

let componentModule = angular.module('app.components', [
  Admin,
  Login,
  User,
  Unauthorized,
  Vehicle,
  Notes,
  EntityManagement,
  AccessoryManagement,
  PriceManagement,
  Company,
  Address,
  ContactPhones,
  ContactEmails,
  Contact,
  Enquiry,
  WelcomeCentre,
  Messaging,
  Dashboard,
  Promise,
  Reports,
  Finance,
  OmniSearch,
  GaugeChart,
  KpiAnalytics,
  LeadMonitor,
  PrivacyPolicy,
  Accounting
])

.service('webEnquiriesService', WebEnquiriesService)

.name;

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/components/components.js